import { media } from '@hellodarwin/core/web/theme/mixins/responsive';
import styled, { css, DefaultTheme, Interpolation } from 'styled-components';
import MediaAsset from '../UI/MediaAsset';
import {
  ContainerContentMarginStylingProps,
  ContainerContentWidthStylingProps,
} from './types';

export interface StyledContainerProps {
  $tablet?: Interpolation<object>;
  $default?: Interpolation<object>;
  $xl?: Interpolation<object>;
  $lg?: Interpolation<object>;
}
export interface StyledMediaAssetProps {
  $tablet?: Interpolation<object>;
  $default?: Interpolation<object>;
  $xl?: Interpolation<object>;
  $lg?: Interpolation<object>;
}
export interface StyledContainerContentProps {
  $tablet?: Interpolation<object>;
  $default?: Interpolation<object>;
  $xl?: Interpolation<object>;
  $lg?: Interpolation<object>;
}

export const ContainerContentMarginStyling = ({
  theme,
}: ContainerContentMarginStylingProps) => css`
  padding-left: 0;
  padding-right: 0;

  padding-top: 45px;
  padding-bottom: 45px;

  @media (min-width: ${theme.breakpoints.tablet}px) {
    padding-top: 70px;
    padding-bottom: 54px;
  }
`;

export const ContainerContentWidthStyling = ({
  theme,
  $cap,
}: ContainerContentWidthStylingProps) => css`
  width: calc(100% - 48px);
  margin: 0 auto;
  max-width: 450px;
  @media (min-width: ${theme.breakpoints.tablet}px) {
    width: calc(100% - 200px);
    max-width: calc(${$cap}px - 300px);
  }

  @media (min-width: ${theme.breakpoints.l}px) {
    max-width: ${$cap}px;
    width: 100%;
  }
`;

export const ContainerContentStyled = styled.section<StyledContainerContentProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  height: fit-content;

  li {
    width: fit-content;
    .hd-text {
      width: fit-content;
      display: inline;
    }
  }

  ${({ $xl, $default, $tablet, $lg }) => css`
    ${$default};
    ${media.xxl`${$xl}`};
    ${media.xl`${$lg}`};
    ${media.tablet`${$tablet}`};
  `}
`;
export const ContainerImage = styled(MediaAsset)<StyledMediaAssetProps>`
  ${({ $xl, $default, $tablet, $lg }) => css`
    ${$default};
    ${media.xxl`${$xl}`};
    ${media.xl`${$lg}`};
    ${media.tablet`${$tablet}`};
  `}
`;
export const GradientStyling = (theme: DefaultTheme, size: number) => css`
  &:after,
  &:before {
    content: '';
    position: absolute;

    left: 0;
    width: 100%;
  }
  &:before {
    top: 0;
    height: ${size}%;
    background: ${theme.colors.beige_1};
  }
  &:after {
    top: ${size}%;
    height: ${100 - size}%;
    background: ${theme.colors.beige_2};
  }
`;
export const ContainerStyled = styled.div<StyledContainerProps>`
  position: relative;
  z-index: 1;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  ${({ $xl, $default, $tablet, $lg }) => css`
    ${$default};
    ${media.xxl`${$xl}`};
    ${media.xl`${$lg}`};
    ${media.tablet`${$tablet}`};
  `}
`;
